/**
 * Global thumbnail cache service
 * Persists across component instances to avoid duplicate API calls
 */

const thumbnailCache = new Map()

export default {
  /**
   * Get cached thumbnail URL
   * @param {string} assetId - Media asset ID
   * @returns {string|null} Cached URL or null if not cached
   */
  get(assetId) {
    return thumbnailCache.get(assetId) || null
  },

  /**
   * Set thumbnail URL in cache
   * @param {string} assetId - Media asset ID
   * @param {string} signedUrl - Signed URL from backend
   */
  set(assetId, signedUrl) {
    thumbnailCache.set(assetId, signedUrl)
  },

  /**
   * Check if asset is cached
   * @param {string} assetId - Media asset ID
   * @returns {boolean}
   */
  has(assetId) {
    return thumbnailCache.has(assetId)
  },

  /**
   * Clear all cached thumbnails
   */
  clear() {
    thumbnailCache.clear()
  },

  /**
   * Clear a specific asset from cache
   * @param {string} assetId - Media asset ID
   */
  remove(assetId) {
    thumbnailCache.delete(assetId)
  },

  /**
   * Get cache size
   * @returns {number} Number of cached items
   */
  size() {
    return thumbnailCache.size
  }
}
